import type { ICasinoLobby } from "../shared/types"
import { defineStore } from "pinia"
import { computed, ref } from "vue"
import { fetchCasinoLobby } from "../api"
import { ENUM_STORE_NAMES } from "../shared/constants"
import { useIsMobile } from "../shared/helpers"

export const useCasinoLobbyStore = defineStore(ENUM_STORE_NAMES.CASINO_LOBBY, () => {
  const loading = ref(false)
  const search = ref("")
  const listCasinoLobby = ref<ICasinoLobby>({} as ICasinoLobby)
  const isMobile = useIsMobile()

  async function fetchLobby(searchQuery = "") {
    loading.value = true
    try {
      const params = {
        ...(searchQuery && { search: searchQuery }),
        device: isMobile.value ? "mobile" : "desktop",
      }
      const response = await fetchCasinoLobby(params)
      setListCasinoLobby(response.data)
    }
    finally {
      loading.value = false
    }
  }

  function setListCasinoLobby(list: ICasinoLobby) {
    listCasinoLobby.value = list
  }

  function setSearch(querySearch: string) {
    search.value = querySearch
  }

  const isEmpty = computed(() => Object.keys(listCasinoLobby.value).length === 0)

  return {
    loading,
    search,
    listCasinoLobby,
    isEmpty,
    fetchLobby,
    setListCasinoLobby,
    setSearch,
  }
})
